// extracted by mini-css-extract-plugin
export var documentation = "_kf-1";
export var menu = "_kf-0";